import Vue from 'vue';

import search from '@/Modules/search/Search';

const resultListing = document.getElementById('js-profile-listing-dynamic');
const prerenderedId = 'js-profile-listing-prerendered';
const resultListingPrerendered = document.getElementById(prerenderedId);
let resultListingPrerenderedHidden = false;

const eventHandlerMethods = {
  transitionEnd(ev) {
    const target = ev.currentTarget;
    let content;
    if (target.classList.contains('profile-listing-item__reverse-content')) {
      content = target;
    } else {
      content = target.querySelector('.profile-listing-item__reverse-content');
    }
    content.style.pointerEvents = 'auto';
  },
  mouseOver(ev) {
    const content = ev.currentTarget.querySelector(
      '.profile-listing-item__reverse-content',
    );
    content.style.pointerEvents = 'auto';
  },
  mouseOut(ev) {
    const content = ev.currentTarget.querySelector(
      '.profile-listing-item__reverse-content',
    );
    content.style.pointerEvents = 'none';
  },
};

const prerenderedRoots = Array.from(
  document.getElementsByClassName('profile-listing-item'),
);
prerenderedRoots.forEach((root) => {
  const reverseContent = root.getElementsByClassName(
    'profile-listing-item__reverse-content',
  )[0];
  if (reverseContent) {
    reverseContent.addEventListener(
      'transitionend',
      eventHandlerMethods.transitionEnd,
    );
  }
  root.addEventListener('mouseover', eventHandlerMethods.mouseOver);
  root.addEventListener('mouseout', eventHandlerMethods.mouseOut);
});

const listingItemsVm =  resultListing
  && new Vue({
    el: resultListing,
    delimiters: ['${', '}'],

    data() {
      return {
        items: search().items,
        itemsDisplayed: [], // displayed dynamic items (replaces prerendered items)
      };
    },

    computed: {
      responseItemsLive() {
        return this.items || [];
      },
    },

    methods: eventHandlerMethods,

    watch: {
      responseItemsLive(newItems) {
        this.itemsDisplayed.splice(0, this.itemsDisplayed.length, ...newItems);
        if (!resultListingPrerenderedHidden) {
          const elementToRemove = resultListingPrerendered;
          elementToRemove.parentNode.removeChild(elementToRemove);
          resultListingPrerenderedHidden = true;
        }
      },
    },
  });
